import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import dialogReducer from '@/features/dialogSlice'
import dialogGroupSpotsReducer from '@/features/dialogGroupSpotsSlice'
import dialogRewardsReducer from '@/features/dialogRewardsSlice'
import dialogPhotoReducer from '@/features/dialogPhotoSlice'
import authReducer from '@/features/authSlice'
import spotMapReducer from '@/features/spotMapSlice'
import AsyncThunkSlice from '@/features/apiAsyncSlice'

export const store = configureStore({
  reducer: {
    dialog: dialogReducer,
    dialogGroupSpots: dialogGroupSpotsReducer,
    dialogRewards: dialogRewardsReducer,
    dialogPhotoState: dialogPhotoReducer,
    spotMap: spotMapReducer,
    auth: authReducer,
    apiAsync: AsyncThunkSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

export type AppDispatch = typeof store.dispatch
